// extracted by mini-css-extract-plugin
module.exports = {"smsSnippetsBtn":"ListSMS_smsSnippetsBtn__1QjrS"};